import { cn } from '@lib/util/cn';

const Divider = ({ className }: { className?: string }) => (
  <hr
    className={cn(
      'h-px w-full border-0 border-b border-gray-200 mt-1',
      className,
    )}
  />
);

export default Divider;
